import { ComponentChildren, h } from "preact";

import classname from "../../../foundation/utils/classname";
import IconClose from "../Icons/IconClose";
import Button, { ButtonProps } from "../Button";
import NinjaTextButton from "../NinjaTextButton";

import styles from "./OnboardingBanner.module.css";

type OnboardingBannerButtonProps = Pick<ButtonProps, "children" | "onClick" | "buttonRef">;

enum ImageSize {
    Compact = "compact",
    Full = "full"
}

enum ButtonsOrientation {
    Horizontal = "horizontal",
    Vertical = "vertical"
}

interface Props {
    class?: string;
    imageSize?: ImageSize;
    image?: ComponentChildren;
    title?: string;
    description: string;
    buttonsOrientation?: ButtonsOrientation;
    primaryButtonProps?: OnboardingBannerButtonProps;
    secondaryButtonProps?: OnboardingBannerButtonProps;
    onClose: () => void;
}

function OnboardingBanner({
    class: cssClass,
    imageSize = ImageSize.Full,
    image,
    title,
    description,
    buttonsOrientation = ButtonsOrientation.Vertical,
    primaryButtonProps,
    secondaryButtonProps,
    onClose
}: Props) {
    return (
        <div
            class={classname(styles.onboardingBanner, cssClass)}>
            {image && (
                <div class={classname(styles.imageContainer, { [styles.compact]: imageSize === ImageSize.Compact })}>
                    {image}
                </div>
            )}
            <div class={styles.body}>
                {title && <span class={classname(styles.title, "body-1 medium")}>{title}</span>}
                <span class={classname(styles.description, "body-1")}>{description}</span>
                <div class={classname(styles.footer, {
                    [styles.vertical]: buttonsOrientation === ButtonsOrientation.Vertical
                })}>
                    {primaryButtonProps && (
                        <Button
                            class={styles.primaryButton}
                            {...primaryButtonProps}/>
                    )}
                    {secondaryButtonProps && <NinjaTextButton {...secondaryButtonProps}/>}
                </div>
            </div>
            <div
                class={styles.iconContainer}
                onClick={onClose}>
                <IconClose/>
            </div>
        </div>
    );
}

export default OnboardingBanner;
export {
    Props as OnboardingBannerProps,
    ImageSize as OnboardingBannerImageSize,
    ButtonsOrientation as OnboardingBannerButtonsOrientiation
};
